import {BaseSearchDTO} from "./baseSearchDTO.interface";

export class ContactAttribSearchDTO extends BaseSearchDTO {
  filters?: {
    contactId?: string;
    attribId?: number;
    statusId?: number;
  };
}
